import type { TeamV5 } from '@/modules/api';

// Sparta's TeamType.CareTeamChatbot — an LLM chat "coach", not a care provider.
const CHATBOT_TEAM_TYPE = 'care-team-chatbot';

/**
 * Whether the member has a primary coach who is not a chatbot, on ANY team — the
 * backend's "completed onboarding" rule (webserver `_get_next_app`, which decides
 * /app vs /onboarding after login) and Sparta's `hasAtLeastOnePrimaryCoach`
 * (initialCurrentUserDataLoadedEpic). The backend excludes by the coach's
 * `coach_type`; we exclude by team type, as Sparta does, because `primaryCoach` is
 * only a URI here. The two are equivalent: a chatbot coach only ever sits on a
 * `care-team-chatbot` team. One difference: the v5 list only returns active
 * memberships, while `_get_next_app` has no active filter, so a coach on a
 * deactivated membership counts there but not here. Unlike `hasPrimaryCoach`, it doesn't depend on the solo
 * team, so a coach on a group team or a member off their solo team still counts.
 */
export function hasAnyPrimaryCoach(teams: TeamV5[]): boolean {
  return teams.some((team) => Boolean(team.primaryCoach) && team.teamType !== CHATBOT_TEAM_TYPE);
}
